import {CALL_API, Call} from 'redux/middleware/api'
import {batchActions} from 'redux-batch-enhancer'

import {getCurrentSitePlease} from 'redux/modules/currentUser/actions'
import {reportError} from 'redux/modules/error/actions'
import {closeConfirm} from 'redux/modules/ui/confirm/actions'
import {
  NOTIFICATION,
  NOTIFICATION_SETUP,
  NOTIFICATION_NUMBER,
  NOTIFICATION_MARK,
  NOTIFICATION_PER_PAGE
} from './'

export function loadNotificationsData(params) {
  return {
    [CALL_API]: {
      types: NOTIFICATION,
      endpoint: `notifications/need_attention`,
      errorsHandled: true,
      queryParams: params
    }
  }
}
export function loadNotificationsNumber(params) {
  return {
    [CALL_API]: {
      types: NOTIFICATION_NUMBER,
      endpoint: `notifications/need_attention`,
      errorsHandled: true,
      queryParams: params
    }
  }
}
export function loadNotificationsSetup(params) {
  return {
    [CALL_API]: {
      types: NOTIFICATION_SETUP,
      endpoint: `notifications/setup`,
      errorsHandled: true,
      queryParams: params
    }
  }
}
export function sendNotification({merchantSiteId, notificationID, status}) {
  return {
    [CALL_API]: {
      endpoint: `notification/${notificationID}`,
      errorsHandled: true,
      method: 'PATCH',
      body: {status, merchantSiteId},
      types: NOTIFICATION_MARK
    }
  }
}
export function fetchNotificationsData(page) {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState)
      .success(merchantSiteId => {
        const fetchParams = {merchantSiteId, page, size: NOTIFICATION_PER_PAGE}
        Call.all(dispatch(batchActions([loadNotificationsData(fetchParams)]))).fail(dispatch(reportError()))
      })
  }
}
export function fetchNotificationsSetupData() {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState)
      .success(merchantSiteId => {
        const fetchParams = {merchantSiteId}
        Call.all([dispatch(loadNotificationsSetup(fetchParams)).success(dispatch(fetchNotificationsData(1)))]).fail(dispatch(reportError()))
      })
  }
}
export function fetchNotificationsNumber() {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState)
      .success(merchantSiteId => {
        const fetchParams = {merchantSiteId, size: 0}
        Call.all(dispatch(batchActions([loadNotificationsNumber(fetchParams)]))).fail(dispatch(reportError()))
      })
  }
}
export function markNotification(status, notificationID) {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState)
      .success(merchantSiteId => {
        const fetchParams = {merchantSiteId, notificationID, status}
        Call.all(dispatch(batchActions([sendNotification(fetchParams)]))).success(dispatch(closeConfirm())).fail(dispatch(closeConfirm()))
      })
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/notifications/actions.js